<div class="loginBg">
  <div class="loginpage">
    <div class="loginBlock">
      <p>Welcome to</p>
      <p>
        <img src="{{config.get('imageUrls').productLogoUrl}}" alt="">
      </p>
      <p class="digiId">Sign in using your HT Digital ID</p>
      <div (click)="signInWithGoogle()">
        <p class="signgoogle">
          <img id="singInButton" src="{{config.get('imageUrls').signInButtonImg}}" alt="">
        </p>
      </div>
      <div class="or"> 
        <p style="margin-top: 3%;">OR</p>
        </div>
        <ng-container>
          <button class="btn btn-lg btn-primary btn-block" (click)="ldapClick()"> Sign in with LDAP</button>
        </ng-container>
      <div class="loginFormBlock" *ngIf="isLdap">
        <form [formGroup]="loginForm" (ngSubmit)="signInWithAD();" class="form-signin" novalidate #myform="ngForm">
          <div class="panel-body">
            <label class="sr-only">Email address</label>
            <input type="text" class="textBox" placeholder="Username" formControlName="email" required autofocus>
            <label class="sr-only">Password</label>
            <input type="password" class="textBox" placeholder="Password" formControlName="idToken" style="margin-top: 10px;"
              required>
            <button class="btn btn-lg btn-primary btn-block" type="submit">Sign In</button>
          </div>
        </form>
      </div>
    </div>
    <div class="loginError" *ngIf="errorMessage">
      <p [innerHTML]="errorMessage"></p>
    </div>
    <div>
    </div>
    <div class="custom-message" *ngIf="!errorMessage">
     {{'Option to login from Gmail will be removed gradually and thus request you to start logging in via LDAP option. In case you face any issues while login, contact the blank paper team.'}}
    </div>
  </div>
</div>
